export class Cliente{
    constructor(
        public _id: string,
        public nombre: string,
        public telefono: number,
        public direccion: string,
        public company: string,
    ){}
}